export const PAY_SCHEDULE_LIST_FILTER_FORM_ID =
  'gp-pay-schedule-pay-schedule-list-filters';

export const PAYRUN_TABLE_FILTER_FORM_ID = 'payrun-table-filters';
